<template>
  <v-card>
    <v-container fluid>
      <v-layout column justify-center align-center pa-4 style="min-height:50vh;">
        <h2 class="text-xs-center primary--text mb-4 text-uppercase">{{texto}}</h2>
        <v-progress-circular indeterminate :size="70" :width="7" color="primary"/>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
export default {
  props: {
    texto: {
      type: String,
      default () {
        return this.$t('general.misc.cargando')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/generic/OMainProgress.vue